import { createAccordionComponent } from '@vfde-brix/accordion';
import { setGigacubeObjectProperty } from '../helper/windowObjectHelper';
import { ACCORDION, WRAPPER_ID_FAQ_ACCORDION } from '../constant';
import { trackFaqAccordionShown } from '../container/App/helpers/tracking';

export const mountAccordion = () => {
    const containerEl = document.getElementById(WRAPPER_ID_FAQ_ACCORDION);

    if (!containerEl) {
        return;
    }

    const accordion = createAccordionComponent(containerEl, {
        onToggle: (accordionItemId?: string, isOpen?: boolean) => {
            if (isOpen) {
                trackFaqAccordionShown(accordionItemId);
            }
        },
    });

    setGigacubeObjectProperty(ACCORDION, accordion);
};
